// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.perxis-auto-1_16_13-tag {
  /* Typography */
  --perxis-auto-tag-font-family-inner: var(--perxis-auto-tag-font-family, var(--perxis-auto-root-typography-marker-font-family-inner));
  --perxis-auto-tag-font-size-inner: var(--perxis-auto-tag-font-size, var(--perxis-auto-root-typography-marker-font-size-xxl-inner));
  --perxis-auto-tag-font-weight-inner: var(--perxis-auto-tag-font-weight, var(--perxis-auto-root-typography-marker-font-weight-inner));
  --perxis-auto-tag-letter-spacing-inner: var(--perxis-auto-tag-letter-spacing, var(--perxis-auto-root-typography-marker-letter-spacing-inner));
  --perxis-auto-tag-line-height-inner: var(--perxis-auto-tag-line-height, 1);
  --perxis-auto-tag-text-transform-inner: var(--perxis-auto-tag-text-transform, var(--perxis-auto-root-typography-marker-text-transform-inner));
  --perxis-auto-tag-color-inner: var(--perxis-auto-tag-color, var(--perxis-auto-root-typography-color-lightest-inner));
  --perxis-auto-tag-icon-font-size-inner: var(--perxis-auto-tag-icon-font-size, 10px);
  /* End Typography */
  /* Colors */
  --perxis-auto-tag-border-color-inner: var(--perxis-auto-tag-border-color, var(--perxis-auto-root-eighth-color-inner));
  --perxis-auto-tag-hover-border-color-inner: var(--perxis-auto-tag-hover-border-color, var(--perxis-auto-tag-border-color-inner));
  --perxis-auto-tag-icon-color-inner: var(--perxis-auto-tag-icon-color, var(--perxis-auto-root-typography-color-lightest-inner));
  --perxis-auto-tag-icon-hover-color-inner: var(--perxis-auto-tag-icon-hover-color, var(--perxis-auto-tag-icon-color-inner));
  --perxis-auto-tag-background-color-inner: var(--perxis-auto-tag-background-color, var(--perxis-auto-root-eighth-color-inner));
  --perxis-auto-tag-border-color-current: var(--perxis-auto-tag-border-color-inner);
  --perxis-auto-tag-icon-color-current: var(--perxis-auto-tag-icon-color-inner);
  /* End Colors */
  /* Border */
  --perxis-auto-tag-border-radius-inner: var(--perxis-auto-tag-border-radius, 10px);
  --perxis-auto-tag-icon-only-border-radius-inner: var(--perxis-auto-tag-icon-only-border-radius, 50%);
  --perxis-auto-tag-border-width-inner: var(--perxis-auto-tag-border-width, 1px);
  /* End Border */
  /* Padding */
  --perxis-auto-tag-padding-inner: var(--perxis-auto-tag-padding, 5px 10px);
  --perxis-auto-tag-icon-only-padding-inner: var(--perxis-auto-tag-icon-only-padding, 5px);
  /* End Padding */
  --perxis-auto-typography-marker-font-family: var(--perxis-auto-tag-font-family-inner);
  --perxis-auto-typography-marker-font-weight: var(--perxis-auto-tag-font-weight-inner);
  --perxis-auto-typography-marker-letter-spacing: var(--perxis-auto-tag-letter-spacing-inner);
  --perxis-auto-typography-marker-text-transform: var(--perxis-auto-tag-text-transform-inner);
  --perxis-auto-typography-color-lightest: var(--perxis-auto-tag-color-inner);
  --perxis-auto-typography-marker-font-size-xxs: var(--perxis-auto-tag-font-size-inner);
  --perxis-auto-typography-marker-font-size-xs: var(--perxis-auto-tag-font-size-inner);
  --perxis-auto-typography-marker-font-size-sm: var(--perxis-auto-tag-font-size-inner);
  --perxis-auto-typography-marker-font-size-md: var(--perxis-auto-tag-font-size-inner);
  --perxis-auto-typography-marker-font-size-lg: var(--perxis-auto-tag-font-size-inner);
  --perxis-auto-typography-marker-font-size-xl: var(--perxis-auto-tag-font-size-inner);
  --perxis-auto-typography-marker-font-size-xxl: var(--perxis-auto-tag-font-size-inner);
  --perxis-auto-typography-marker-line-height-xxs: var(--perxis-auto-tag-line-height-inner);
  --perxis-auto-typography-marker-line-height-xs: var(--perxis-auto-tag-line-height-inner);
  --perxis-auto-typography-marker-line-height-sm: var(--perxis-auto-tag-line-height-inner);
  --perxis-auto-typography-marker-line-height-md: var(--perxis-auto-tag-line-height-inner);
  --perxis-auto-typography-marker-line-height-lg: var(--perxis-auto-tag-line-height-inner);
  --perxis-auto-typography-marker-line-height-xl: var(--perxis-auto-tag-line-height-inner);
  --perxis-auto-typography-marker-line-height-xxl: var(--perxis-auto-tag-line-height-inner);
  --antd-wave-shadow-color: transparent;
  --wave-color: transparent;
}
.perxis-auto-1_16_13-tag[ant-5_17_0-click-animating-without-extra-node=true]::after,
.perxis-auto-1_16_13-tag > *[ant-5_17_0-click-animating-without-extra-node=true]::after {
  animation: none !important;
}
.perxis-auto-1_16_13-tag .ant-5_17_0-wave {
  transition: none !important;
}
.perxis-auto-1_16_13-tag.ant-5_17_0-tag {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: var(--perxis-auto-tag-font-size-inner);
  line-height: var(--perxis-auto-tag-line-height-inner);
  color: var(--perxis-auto-tag-color-inner);
  background-color: var(--perxis-auto-tag-background-color-inner);
  padding: var(--perxis-auto-tag-padding-inner);
  border-style: solid;
  border-width: var(--perxis-auto-tag-border-width-inner);
  border-color: var(--perxis-auto-tag-border-color-current);
  border-radius: var(--perxis-auto-tag-border-radius-inner);
}
.perxis-auto-1_16_13-tag.ant-5_17_0-tag:hover {
  --perxis-auto-tag-border-color-current: var(--perxis-auto-tag-hover-border-color-inner);
  --perxis-auto-tag-icon-color-current: var(--perxis-auto-tag-icon-hover-color-inner);
}
.perxis-auto-1_16_13-tag.ant-5_17_0-tag .perxis-auto-1_16_13-tag__icon,
.perxis-auto-1_16_13-tag.ant-5_17_0-tag .ant-5_17_0-tag-close-icon {
  display: inline-flex;
  align-items: center;
  margin: 0;
  font-size: var(--perxis-auto-tag-icon-font-size-inner);
  color: var(--perxis-auto-tag-icon-color-current);
}
.perxis-auto-1_16_13-tag.ant-5_17_0-tag.perxis-auto-1_16_13-tag--icon-position-left .perxis-auto-1_16_13-tag__icon {
  order: 0;
}
.perxis-auto-1_16_13-tag.ant-5_17_0-tag.perxis-auto-1_16_13-tag--icon-position-right .perxis-auto-1_16_13-tag__icon {
  order: 1;
}
.perxis-auto-1_16_13-tag.ant-5_17_0-tag.perxis-auto-1_16_13-tag--icon-only {
  padding: var(--perxis-auto-tag-icon-only-padding-inner);
  border-radius: var(--perxis-auto-tag-icon-only-border-radius-inner);
}
.perxis-auto-1_16_13-tag.ant-5_17_0-tag.perxis-auto-1_16_13-tag--icon-only .perxis-auto-1_16_13-tag__icon {
  min-width: var(--perxis-auto-tag-icon-font-size-inner);
}
.perxis-auto-1_16_13-tag.ant-5_17_0-tag .ant-5_17_0-tag-close-icon {
  order: 2;
}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
